/**
 * Canonical type definitions for company_settings JSONB fields.
 * 
 * These types are the SINGLE SOURCE OF TRUTH for the frontend.
 * Edge functions maintain a mirrored copy at supabase/functions/_shared/companySettingsTypes.ts
 * 
 * ⚠️ IMPORTANT: Any changes here MUST be mirrored in:
 *   - supabase/functions/_shared/companySettingsTypes.ts (edge functions)
 *   - SQL validation in set_company_settings RPC (migration 20251008115247)
 *     which validates: enabled, minimumGapMinutes, minimumShiftLengthMinutes, countMultiplePerDay
 */

/** Configuration for split-shift detection stored in company_settings.split_shift_config */
export interface SplitShiftConfig {
  enabled: boolean;
  minimumGapMinutes: number;
  minimumShiftLengthMinutes: number;
  countMultiplePerDay: boolean;
}

/** Status of the last holiday sync stored in company_settings.holiday_sync_status */
export interface HolidaySyncStatus {
  last_sync?: string;
  country_code?: string;
  region_code?: string | null;
  year?: number;
  api_source?: string;
  holiday_count?: number;
  status?: 'success' | 'error' | 'cache';
  error_message?: string;
  metadata?: Array<{ date: string; name?: string; source?: 'api' | 'custom' }>;
  excluded_api_dates?: string[];
}

/** Default split-shift config matching the DB column default */
export const DEFAULT_SPLIT_SHIFT_CONFIG: SplitShiftConfig = {
  enabled: true,
  minimumGapMinutes: 60,
  minimumShiftLengthMinutes: 30,
  countMultiplePerDay: true,
};
